import React from 'react';
import { Collapse } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import { Text } from 'components/tt-forms/common';
import moment from 'moment';
import { header } from 'constants/table';
import {
  RowItemListAttachReceptionPeriodical
} from 'modules/reception-periodical/datatable/detail';

class ThongTinCoQuanDaGiaiQuyet extends React.Component {

  render() {
    return (
      <div className="box-forward">

          <div className="group-box">
            <Collapse isOpen={this.props.isOpen}>
              <div className="title">
                <div className="rows">
                  <div className="col-12">
                    <h3>{this.props.title}</h3>
                  </div>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Cơ quan đã giải quyết:"
                    value={this.props.parent.data.coQuanDaGiaiQuyetDonThu || ''} />
                  <Text
                    className="col-input"
                    label="Số văn bản:"
                    value={this.props.parent.data.soVanBanDaGiaiQuyet ? this.props.parent.data.soVanBanDaGiaiQuyet : ''} />
                  <Text
                    className="col-input"
                    label="Ngày ban hành:"
                    value={this.props.parent.data.ngayBanHanhVanBanDaGiaiQuyet ? moment(this.props.parent.data.ngayBanHanhVanBanDaGiaiQuyet).format("DD/MM/YYYY") : ''} />
                </div>
              </div>

              <div className="title">
                <div className="rows">
                  <div className="col-12 pt15">
                    <h3>Danh sách văn bản xử lý</h3>
                  </div>
                </div>
              </div>
              <div className="items-form white-table">
                <div className="rows">
                  <div className="col-12">
                    <DataTable
                      header = {header.detailReceptionPeriodical.attach}
                      dataList = {this.props.parent.data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet}
                      hidePagination={true}>
                      <RowItemListAttachReceptionPeriodical/>
                    </DataTable>
                  </div>
                </div>
              </div>

            </Collapse>
          </div>

      </div>
    );
  }
}

ThongTinCoQuanDaGiaiQuyet.defaultProps = {
  parent: {
    listTaiLieuVanThuBlockCoQuanDaGiaiQuyet : []
  }
}

export default ThongTinCoQuanDaGiaiQuyet;



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/ThongTinCoQuanDaGiaiQuyet.jsx